module.exports = __webpack_public_path__ + "img/INTERIOR-VITARA-3.80ac0905.jpg";